import { useQuery, useMutation, useQueryClient } from 'react-query';
import { GetUGroups, CreateUGroup, UpdateUGroup, DeleteUGroup, AddUserToUGroup, RemoveUserFromUGroup, GetUGroupByUserId, GetUGroupByUrl, GetUGroupByFunction } from '../services/backend';
import { Notify, NotifyError } from '../utils/functions';

export function useGetUGroups(filters = {}) {
    return useQuery(
        ['user-groups', filters], () => GetUGroups(filters), {
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000, // 5 minutes
        select: (data) => {
            return data?.data?.userGroups || [];
        },
        onError: (error) => {
            NotifyError('Failed to fetch user groups', error);
            console.error('Error fetching user groups:', error);
        }
    });
}

export function useCreateUGroup() {
    const queryClient = useQueryClient();

    return useMutation(CreateUGroup, {
        onSuccess: () => {
            Notify('User group created successfully', 'success');
            queryClient.invalidateQueries('user-groups');
        },
        onError: (error) => {
            NotifyError('Failed to create user group', error);
            console.error('Error creating user group:', error);
        }
    });
}

export function useUpdateUGroup() {
    const queryClient = useQueryClient();

    return useMutation(({ userGroupId, data }) => UpdateUGroup(userGroupId, data), {
        onSuccess: () => {
            Notify('User group updated successfully', 'success');
            queryClient.invalidateQueries('user-groups');
        },
        onError: (error) => {
            NotifyError('Failed to update user group', error);
            console.error('Error updating user group:', error);
        }
    });
}

export function useDeleteUGroup() {
    const queryClient = useQueryClient();

    return useMutation(DeleteUGroup, {
        onSuccess: () => {
            Notify('User group deleted successfully', 'success');
            queryClient.invalidateQueries('user-groups');
        },
        onError: (error) => {
            NotifyError('Failed to delete user group', error);
            console.error('Error deleting user group:', error);
        }
    });
}

export function useAddUserToUGroup() {
    const queryClient = useQueryClient();

    return useMutation(AddUserToUGroup, {
        onSuccess: () => {
            Notify('User added to user group successfully', 'success');
            queryClient.invalidateQueries('user-groups');
        },
        onError: (error) => {
            NotifyError('Failed to add user to user group', error);
            console.error('Error adding user to user group:', error);
        }
    });
}

export function useRemoveUserFromUGroup() {
    const queryClient = useQueryClient();

    return useMutation(RemoveUserFromUGroup, {
        onSuccess: () => {
            Notify('User removed from user group successfully', 'success');
            queryClient.invalidateQueries('user-groups');
        },
        onError: (error) => {
            NotifyError('Failed to remove user from user group', error);
            console.error('Error removing user from user group:', error);
        }
    });
}

export function useGetUGroupByUserId() {
    return useQuery(
        ['user-group', 'user-id'],
        GetUGroupByUserId, {
        onSuccess: (data) => {
            return data?.data?.userGroup || null;
        },
        onError: (error) => {
            NotifyError('Failed to get user group by user id', error);
            console.error('Error getting user group by user id:', error);
        }
    });
}

export function useGetUGroupByUrl() {
    return useQuery(
        ['user-group', 'url'],
        GetUGroupByUrl, {
        onSuccess: (data) => {
            return data?.data?.userGroup || null;
        },
        onError: (error) => {
            NotifyError('Failed to get user group by url', error);
            console.error('Error getting user group by url:', error);
        }
    });
}

export function useGetUGroupByFunction() {
    return useQuery(
        ['user-group', 'function'],
        GetUGroupByFunction, {
        onSuccess: (data) => {
            return data?.data?.userGroup || null;
        },
        onError: (error) => {
            NotifyError('Failed to get user group by function', error);
            console.error('Error getting user group by function:', error);
        }
    });
}